import { v4 as uuidv4 } from 'uuid';
import {
  COTIZADOR_GET_VEHICLES_SEGMENT_BEGIN,
  COTIZADOR_GET_VEHICLES_SEGMENT_SUCCESS,
  COTIZADOR_GET_VEHICLES_SEGMENT_FAILURE,
  COTIZADOR_GET_VEHICLES_SEGMENT_DISMISS_ERROR,
} from './constants';
import { getVehicleSegments } from 'BFF/BFF_cotizador/getVehicleSegments';


export function getVehiclesSegment(id, filter) {
  return async (dispatch) => {
    // optionally you can have getState as the second argument
    dispatch({
      type: COTIZADOR_GET_VEHICLES_SEGMENT_BEGIN,
    })

    try {

      const result = await getVehicleSegments(id, filter);

      // Se recorre el arreglo de vehiculos
      // Se agregan ids a los que no lo tienen
      result.data.data.forEach( vehicle => {
        if(!vehicle.id) vehicle.id = uuidv4();
      })
      
      dispatch({
        type: COTIZADOR_GET_VEHICLES_SEGMENT_SUCCESS,
        data: result.data,
      });

    } catch (err) {
      dispatch({
        type: COTIZADOR_GET_VEHICLES_SEGMENT_FAILURE,
        data: { error: err },
      });
    }
  }
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissGetVehiclesSegmentError() {
  return {
    type: COTIZADOR_GET_VEHICLES_SEGMENT_DISMISS_ERROR,
  }
}

export function reducer(state, action) {
  switch (action.type) {
    case COTIZADOR_GET_VEHICLES_SEGMENT_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        getVehiclesSegmentPending: true,
        getVehiclesSegmentError: null,
      }

    case COTIZADOR_GET_VEHICLES_SEGMENT_SUCCESS:
      // The request is success
      return {
        ...state,
        getVehiclesSegmentPending: false,
        getVehiclesSegmentError: null,
        vehicles: action.data,
      }

    case COTIZADOR_GET_VEHICLES_SEGMENT_FAILURE:
      // The request is failed
      return {
        ...state,
        getVehiclesSegmentPending: false,
        getVehiclesSegmentError: action.data.error,
      }

    case COTIZADOR_GET_VEHICLES_SEGMENT_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        getVehiclesSegmentError: null,
      }

    default:
      return state
  }
}
